/**
 * Le icone del tipo delle schede, uguali in elenco, dettaglio e modale.
 */

import { watchSquare } from '@lucide/lab';
import { ClipboardListIcon, createLucideIcon, type LucideIcon } from 'lucide-react';
import type { TipoScheda } from '@calcio/shared';

const WatchSquare = createLucideIcon('watch-square', watchSquare);

export const ICONA_TIPO_SCHEDA: Record<TipoScheda, LucideIcon> = {
  // L'esercizio ha l'icona della voce «Libreria schede», la partita il cronometro.
  esercizio: ClipboardListIcon,
  partita: WatchSquare,
};
